import { useMemo } from 'react';
import ReviewCard from '@/components/ReviewCard';
import { pairReviews } from '@/fixtures/reviews';
import { cn } from '@/lib/utils';
interface ReviewGridProps {
  className?: string;
  reviewCardClassName?: string;
  reviewColumnClassName?: string;
}

/**
 * The Trustpilot review wall, shared by the pricing page and the About page.
 *
 * The row is intentionally wider than the viewport and centred, so it hangs
 * off both edges. Clipping here keeps it out of the page's scroll width — its
 * own `overflow-hidden` only clips its children (DEV-6595).
 */
export const ReviewGrid = ({
  className,
  reviewColumnClassName,
  reviewCardClassName
}: ReviewGridProps) => {
  const pairedReviews = useMemo(() => pairReviews(), []);
  return <div className={cn('relative grid auto-rows-[minmax(0,0)] grid-cols-1 grid-rows-2 overflow-hidden overflow-y-hidden px-4 sm:flex sm:max-h-144 sm:flex-row sm:gap-x-8', className)} data-sentry-component="ReviewGrid" data-sentry-source-file="ReviewGrid.tsx">
      {pairedReviews.map(pair => <div className={cn('flex flex-col items-start gap-8', reviewColumnClassName)} key={pair[0].heading}>
          {pair.map(review => <ReviewCard flag={review.flag} heading={review.heading} key={review.heading} name={review.name} rating={review.rating} review={review.review} className={reviewCardClassName} />)}
        </div>)}
      <div className="pointer-events-none absolute top-0 h-full w-full bg-linear-to-t from-white via-30% via-transparent dark:from-gray-950 dark:via-30% dark:via-transparent" />
    </div>;
};